import React from 'react';
import './NewspaperEffect.css';

interface NewspaperEffectProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'error';
}

export function NewspaperEffect({
  children,
  className = '',
  variant = 'default'
}: NewspaperEffectProps) {
  return (
    <div className={`newspaper-effect newspaper-effect--${variant} ${className}`}>
      <div className="newspaper-effect__content">
        {children}
      </div>
    </div>
  );
}
